import React, { useState, useEffect } from "react";
import Card from "../../../components/Global/Card";
import { AiOutlineTeam } from "react-icons/ai";
import DataTable from "../../../components/Global/DataTable"; // Supondo que o DataTable está neste diretório
import Modal from "../../../components/Global/Modal";
import { CustomService } from "../../../services/api/custom/CustomService";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import GoBack from "../../../components/Utils/GoBack";
import { toast } from "react-toastify";

const ColaboratorsPage = ({ isAuthenticated, user }) => {
  const [data, setData] = useState([]);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [toRemove, setToRemove] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Verifica se é admin, se não for não tem permissão de acessar a página
    if (!user.admin) {
      navigate(`/dashboard`);
    } else {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await CustomService.getRequest("/interno/colaboradores");
      // Apenas admin pode excluir administradores
      if (!user.admin) {
        data.filter((colaborator) => !colaborator.admin);
      }
      setData(data);
    } catch (error) {
      console.error("Erro ao buscar colaboradores:", error);
    } finally {
      setLoading(false); // Finalizar carregamento
    }
  };

  const columns = [
    {
      title: "CPF",
      dataIndex: "cpf",
      key: "cpf",
    },
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  const actions = {
    onDelete: (record) => {
      setToRemove(record);
      setShowRemoveModal(true);
    },
  };

  const removeColaborator = () => {
    try {
      CustomService.deleteRequest(`/interno/colaboradores/${toRemove.id}`);
    } catch (error) {
      toast.error("Erro ao excluir colaborador");
    } finally {
      setToRemove(null);
      setShowRemoveModal(false);
    }
  };

  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/dashboard" />
      {showRemoveModal && (
        <Modal
          buttonName="Excluir"
          title="Confirmar exclusão"
          handleModal={setShowRemoveModal}
          eventConfirmation={() => removeColaborator()}
          size="md:w-1/3"
        >
          <div className="flex flex-col justify-center items-center">
            <span>
              Deseja excluir o colaborador <b>{toRemove.nome}</b> ?
            </span>
            <span className="text-[14px]"> Esta ação é irreversível</span>
          </div>
        </Modal>
      )}
      <Card
        buttonActionPath="/cadastro/colaborador"
        title="Colaboradores"
        icon={<AiOutlineTeam className="w-[25px] h-[25px]" />}
      >
        <div className="w-full">
          {/* DataTable integrado */}
          <DataTable
            size="100%"
            data={data}
            columns={columns}
            paginationOptions={{ pageSize: 5000000000 }}
            actions={actions}
            loading={loading}
          />
        </div>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  login: (userData) => dispatch({ type: "LOGIN_SUCCESS", payload: userData }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ColaboratorsPage);
